import { observer } from "@formily/react";
import { QRCode } from "antd";

interface RumbleQrCodeProps {
  url?: string;
  className?: string;
}

export const RumbleQrCode = observer((props: RumbleQrCodeProps) => {
  if (!props.url) {
    return null;
  }

  return <QRCode className={props.className} value={props.url} />;
});

export default RumbleQrCode;
